import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../assets/styles/productIframe.css";
import productApi from "../api/product/productApi";
import ENV from "../consts/config";
import { currencyFormat } from "../utils/index";

const ProductIframe = (props) => {
  let { id } = useParams();

  const [product, setProduct] = useState();

  useEffect(() => {
    getProduct(id);
  }, []);

  const getProduct = (id) => {
    productApi.getProduct(id).then((res) => {
      if (res) {
        setProduct(res);
      }
    });
  };
  return (
    <>
      <div className="article-detail__ads-box">
        <img
          src={`${ENV.CDN_URL}${product?.avatar}`}
          alt="physa"
          className="article-detail__ads-img"
        />
        <div className="article-detail__ads-info">
          <h3 className="article-detail__ads-heading">
            {product?.name}
            <span className="article-detail__ads-discount">15%</span>
          </h3>
          <div className="article-detail__ads-uses">
          Trị xoắn ngọn, xoắn lá
          </div>
          <div className="article-detail__ads-price">
            <span className="article-detail__ads-current-price">
              {currencyFormat(product?.price || 0)} VNĐ
            </span>
            &nbsp;
            <span className="article-detail__ads-original-price">
              {currencyFormat(product?.salePrice || 0)} VNĐ
            </span>
          </div>
          <div className="article-detail__ads-rating">
            <svg
              width={11}
              height={10}
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z"
                fill="#F9B402"
              />
            </svg>
            <svg
              width={11}
              height={10}
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z"
                fill="#F9B402"
              />
            </svg>
            <svg
              width={11}
              height={10}
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z"
                fill="#F9B402"
              />
            </svg>
            <svg
              width={11}
              height={10}
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z"
                fill="#F9B402"
              />
            </svg>
            <svg
              width={11}
              height={10}
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.5 0L6.73483 3.80041H10.7308L7.49799 6.14919L8.73282 9.94959L5.5 7.60081L2.26718 9.94959L3.50201 6.14919L0.269189 3.80041H4.26517L5.5 0Z"
                fill="#F9B402"
              />
            </svg>
          </div>
          <span className="btn btn-primary article-detail__ads-cart-btn">
            Thêm vào giỏ hàng
          </span>
          <svg
            width={18}
            height={17}
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="article-detail__ads-heart-btn"
          >
            <path
              d="M12.6875 0C11.165 0 9.70375 0.70875 8.75 1.82875C7.79625 0.70875 6.335 0 4.8125 0C2.1175 0 0 2.1175 0 4.8125C0 8.12 2.975 10.815 7.48125 14.91L8.75 16.0563L10.0188 14.9013C14.525 10.815 17.5 8.12 17.5 4.8125C17.5 2.1175 15.3825 0 12.6875 0ZM8.8375 13.6062L8.75 13.6938L8.6625 13.6062C4.4975 9.835 1.75 7.34125 1.75 4.8125C1.75 3.0625 3.0625 1.75 4.8125 1.75C6.16 1.75 7.4725 2.61625 7.93625 3.815H9.5725C10.0275 2.61625 11.34 1.75 12.6875 1.75C14.4375 1.75 15.75 3.0625 15.75 4.8125C15.75 7.34125 13.0025 9.835 8.8375 13.6062Z"
              fill="#3FA000"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default ProductIframe;
